// extracted by mini-css-extract-plugin
export var filterIncDec = "_e7-0";
export var leftBorder = "_e7-1";
export var rightBorder = "_e7-2";
export var stringInput = "_e7-3";